import apiFetch from '../../apiFetch'

export default function (dossierId, lastAccessDate, token) {
  return apiFetch({ endPoint: `dossier/purchase/${dossierId}/changeSubType`, method: 'PUT', body: null, token: token, lastAccessDate: lastAccessDate })
}
